// extracted by mini-css-extract-plugin
module.exports = {"bar":"Home_bar__1MXBP","avatar":"Home_avatar__1vqY3"};